import { render, staticRenderFns } from "./rosterDtl.vue?vue&type=template&id=813aa25a&scoped=true&"
import script from "./rosterDtl.vue?vue&type=script&lang=js&"
export * from "./rosterDtl.vue?vue&type=script&lang=js&"
import style0 from "./rosterDtl.vue?vue&type=style&index=0&id=813aa25a&prod&scoped=true&lang=css&"
import style1 from "./rosterDtl.vue?vue&type=style&index=1&id=813aa25a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813aa25a",
  null
  
)

export default component.exports